import React, { useEffect, useState } from "react";
import axios from "axios";
import { AddUser, DeleteUser, EditUser } from "./modal";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


export const getUserList = async (companyProfileIDs: string) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/api/Users/ApplicationUsers/GetUserWithCompanyAndRoles?companyProfileIDs=${companyProfileIDs}`
        );

        return res.data;
    } catch (error) {
        // console.log("@@Error:", error);
        return error;
    }
};
export const getAllUserList = async () => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/api/Users/ApplicationUsers/GetAllDetailsOfUserWithCompanyAndRoles`
        );

        return res.data;
    } catch (error) {
        // console.log("@@Error:", error);
        return error;
    }
};
export const getRoles = async () => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/api/Users/ApplicationUsers/user-roles`
        );

        return res.data;
    } catch (error) {
        // console.log("@@Error:", error);
        return error;
    }
};

export const getCompanyProfileList = async (userId: number) => {
    try {

        const res = await axios.get(
            `${API_BASE_URL}/api/Users/ComapanyProfile/${userId}/Details`,
        )
        return res.data.data;
    } catch (error) {
        return error;
    }
};
export const getAllCompanyProfileList = async () => {
    try {

        const res = await axios.get(
            `${API_BASE_URL}/api/Users/ComapanyProfile/Details`,
        )
        return res.data.data;
    } catch (error) {
        return error;
    }
};

export const AddUserPost = async (payload: AddUser) => {
    try {
        const res = await axios.post(
            `${API_BASE_URL}/api/Users/ApplicationUsers/Add`,
            payload
        );
        return res.data;
    } catch (error) {
        return error;
    }
};

export const EditUserPost = async (payload: EditUser) => {
    try {
        const res = await axios.put(
            `${API_BASE_URL}/api/Users/ApplicationUsers/Update`,
            payload
        );
        return res.data;
    } catch (error) {
        return error;
    }
};

export const DeleteUserApi = async (payload: DeleteUser) => {
    try {
        const res = await axios.delete(
            `${API_BASE_URL}/api/Users/ApplicationUsers/Delete`,
            {
                data: payload,
            }
        );
        return res.data;
    } catch (error) {
        return error;
    }
};
